import { render, staticRenderFns } from "./SettingTelephone.vue?vue&type=template&id=0434ca4a"
import script from "./SettingTelephone.vue?vue&type=script&lang=js"
export * from "./SettingTelephone.vue?vue&type=script&lang=js"
import style0 from "./SettingTelephone.vue?vue&type=style&index=0&id=0434ca4a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports